function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './AccountAuthorization.css';
import React, { useEffect, useRef, useState } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { canUseDOM, get } from '../../utils';
import AuthLayout from './components/AuthLayout';
import RegisterStep from './RegisterStep';
import EmailAuthentication from './EmailAuthentication';
import TravellersType from './TravellersType';
import HobbiesOrInterests from './HobbiesOrInterests';
import Recaptcha from './components/Recaptcha';
import { qsToObject } from '../../utils/querystring';
import { getLatestUserCookie, getUserCookie } from './user_session';
import { loaderToggle } from '../../utils/setUserCookie';
import Login from './Login';
import OTPForm from './OTPForm';
import SuccessStep from './components/SuccessStep';
import { fetchData } from '../../utils/fetchData';
import { SHA256 } from '../../utils/sha256';
import Hjson from 'hjson';
import { convertToAnalyticObject } from '../../utils/analytics';
export const STEPS = {
  STEP1: 'emailAuthentication',
  STEP2: 'register',
  STEP3: 'travellersType',
  STEP4: 'hobbiesAndInterests',
  STEP5: 'successRegister',
  STEP6: 'login',
  STEP7: 'OTP'
};
export const OTP_BASE_TIMER = 120;
const AccountAuthorization = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [recaptchaError, setRecaptchaError] = useState('');
  const recaptchaRef = useRef(null);
  const [activeStep, setActiveStep] = useState(STEPS.STEP1);
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const logoImage = get(fields, 'data.datasource.logoImage');
  const logoLink = get(fields, 'data.datasource.logoLink');

  // email auth text
  const welcomeTitle = get(fields, 'data.datasource.welcomeTitle.jss.value');
  const welcomeSubtitle = get(fields, 'data.datasource.welcomeSubtitle.jss.value');
  const welcomeImage = get(fields, 'data.datasource.welcomeImage');

  // register auth text
  const createAccountTitle = get(fields, 'data.datasource.createAccountTitle.jss.value');
  const createAccountSubtitle = get(fields, 'data.datasource.createAccountSubtitle.jss.value');
  const createAccountImage = get(fields, 'data.datasource.createAccountImage');

  // login auth text
  const loginTitle = get(fields, 'data.datasource.loginTitle.jss.value');
  const loginSubtitle = get(fields, 'data.datasource.loginSubtitle.jss.value');
  const loginImage = get(fields, 'data.datasource.loginImage');
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const interestingSections = get(fields, 'data.datasource.interestingSections') || [];
  const travellersSection = interestingSections.length ? interestingSections[0] : [];
  const hobbiesSection = interestingSections.length ? interestingSections[1] : [];
  const travellersSectionImage = get(travellersSection, 'image') || {};
  const hobbiesSectionImage = get(hobbiesSection, 'image') || {};
  const travellersSectionTitle = get(travellersSection, 'title.jss.value') || '';
  const travellersSectionSubtitle = get(travellersSection, 'subtitle.jss.value') || '';
  const hobbiesSectionTitle = get(hobbiesSection, 'title.jss.value') || '';
  const hobbiesSectionSubtitle = get(hobbiesSection, 'title.jss.value') || '';
  const successTitle = get(fields, 'data.datasource.successTitle.jss.value') || '';
  const successSubtitle = get(fields, 'data.datasource.successSubtitle.jss.value') || '';
  const successIconCode = get(fields, 'data.datasource.successIconCode.jss.value') || '';
  const successImage = get(fields, 'data.datasource.successImage') || '';
  const loginOTPTitle = get(fields, 'data.datasource.loginOTPTitle.jss.value');
  const loginOTPSubtitle = get(fields, 'data.datasource.loginOTPSubtitle.jss.value');
  const loginOTPImage = get(fields, 'data.datasource.loginOTPImage');
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const recaptchErrorMessage = mapDictionary.get('error recaptcha required');
  const skipButtonLabel = mapDictionary.get('skip');
  const [userEmail, setUserEmail] = useState('');
  const [userFirstName, setFirstName] = useState('');
  const [registerData, setRegisterData] = useState({});
  const [bmCookies, setBMCookies] = useState({});
  const [resetRecaptcha, setResetRecaptcha] = React.useState(false);
  const [formResponseError, setFormResponseError] = useState('');
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [globalLoader, showGlobalLoader] = useState(false);
  const generalErrorCode = 'Failed';
  let formPostErrors = [];
  formPostErrors.push({
    errorCode: generalErrorCode,
    message: mapDictionary.get('Registration api fail error')
  });
  formPostErrors.push({
    errorCode: 'DuplicateUserName',
    message: mapDictionary.get('Formsubmit Api User Already Registered Error')
  });
  formPostErrors.push({
    errorCode: 'FirstName',
    message: mapDictionary.get('Formsubmit Api first name not valid error')
  });
  formPostErrors.push({
    errorCode: 'LastName',
    message: mapDictionary.get('Formsubmit Api last name not valid error')
  });
  formPostErrors.push({
    errorCode: 'Password',
    message: mapDictionary.get('Formsubmit Api password not valid error')
  });

  //
  formPostErrors.push({
    errorCode: 'ConfirmPassword',
    message: mapDictionary.get('form submit api passwords dont match error')
  });
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://replaceapiGlobal';
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  const goBackLabel = mapDictionary.get('backToHome') || '';
  const [registerSuccessData, setRegisterSuccessData] = useState(null);
  const redirectHome = get(fields, 'data.contextItem.redirectPage.jss.value.href');
  const [otpTimer, setOtpTimer] = useState(OTP_BASE_TIMER);
  const loginStatus = getUserCookie().login_status;
  const [allowRender] = useState(!loginStatus);
  const [requestEvisaToken, setRequestEvisaToken] = useState(false);
  let referBack = false;
  let referrer = '/';
  let urlParams = null;
  if (canUseDOM) {
    urlParams = qsToObject(window.location.search);
    if (urlParams.redirect_url && urlParams.redirect_url.length) {
      referBack = true;
      referrer = urlParams.redirect_url;
    }
  }
  let homeURL;
  if (canUseDOM) {
    homeURL = window.location.origin;
    homeURL += redirectHome;
  }
  const getEvisaToken = async userAccessToken => {
    let formdata = new FormData();
    let scope = urlParams.scope;
    if (scope) {
      scope = scope.replace(/\+/g, ' ');
    }
    formdata.append('grant_type', 'visitdubai');
    formdata.append('client_id', urlParams.client_id);
    formdata.append('client_secret', urlParams.client_secret);
    formdata.append('scope', scope);
    formdata.append('token', userAccessToken);
    let myHeaders = new Headers();
    let requestOptions = {
      credentials: 'include',
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: myHeaders
    };
    let statusCode = 0;
    await fetch(`${identityGlobal}/connect/token`, requestOptions).then(response => {
      statusCode = response.status;
      return response.text();
    }).then(result => {
      loaderToggle(false, setDisableSubmit);
      showGlobalLoader(false);
      let responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 200) {
        debugger;
        window.location.href = `${urlParams.return_url}?access_token=${responseObj.access_token}`;
      } else {
        throw Error(generalErrorCode);
      }
    }).catch(error => {
      loaderToggle(false, setDisableSubmit);
      showGlobalLoader(false);
      throw Error(generalErrorCode);
    });
  };
  const applySSOReg = () => {
    if (canUseDOM && urlParams !== null) {
      const requiredParams = ['client_id', 'client_secret', 'scope', 'return_url'];
      const missingParams = requiredParams.filter(key => !urlParams[key]);
      return missingParams.length === 0 && urlParams.client_id === 'gdrfa';
    }
    return false;
  };
  useEffect(() => {
    if (applySSOReg()) {
      console.log('getEvisaToken account auth');
      setRequestEvisaToken(true);
    }
  }, []);
  useEffect(() => {
    if (loginStatus) {
      if (canUseDOM) {
        if (referBack) {
          getLatestUserCookie(identityGlobal, clientId, clientSecret).then(userCookie => {
            setBMCookies({
              ak_bmsc: userCookie.ak_bmsc,
              bm_mi: userCookie.bm_mi,
              bm_sv: userCookie.bm_sv,
              bm_sz: userCookie.bm_sz,
              _abck: userCookie._abck
            });
            if (userCookie && userCookie.access_token) {
              window.location = referrer;
              fetchData({
                path: `${apiGlobal}/graphql/user`,
                options: {
                  method: 'POST',
                  body: JSON.stringify({
                    query: `{ userProfile { email } }`
                  })
                },
                authToken: userCookie.access_token
              }).then(data => {
                const {
                  email: ddd
                } = data.data.userProfile;
                const encrEmail = SHA256(ddd);
                if (typeof window !== 'undefined') {
                  const wind = window;
                  if (wind.utag_data) {
                    wind.utag_data.cust_id = encrEmail;
                  }
                  const utag_data = document.getElementById('utag_data');
                  if (utag_data && utag_data.innerHTML) {
                    const startIndex = utag_data.innerHTML.indexOf('{');
                    const data = Hjson.parse(utag_data.innerHTML.slice(startIndex));
                    data.cust_id = encrEmail;
                    utag_data.innerHTML = `var utag_data = ${JSON.stringify(data)}`;
                  }
                }
              });
            }
          });
        } else if (applySSOReg()) {
          getLatestUserCookie(identityGlobal, clientId, clientSecret).then(userCookie => {
            if (userCookie && userCookie.access_token) {
              console.log('getEvisaToken account auth with token', userCookie.access_token);
              getEvisaToken(userCookie.access_token);
            }
          });
        } else {
          window.location.href = homeURL;
        }
      }
    } else {
      getLatestUserCookie(identityGlobal, clientId, clientSecret).then(_ref2 => {
        let {
          ak_bmsc,
          bm_mi,
          bm_sv,
          bm_sz,
          _abck
        } = _ref2;
        return setBMCookies({
          ak_bmsc,
          bm_mi,
          bm_sv,
          bm_sz,
          _abck
        });
      });
    }
  }, []);
  useEffect(() => {
    if (canUseDOM) {
      const html = document.scrollingElement || document.documentElement;
      if (html) {
        html.scrollTop = 0;
      }
    }
  }, [activeStep]);
  if (!fields) {
    console.warn('AccountAuthorization component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[AccountAuthorization component is empty: please provide datasource]");
    }
    return null;
  }
  const formatText = (text, replaceItem, replacedByTitle) => text ? text.replace(replaceItem, replacedByTitle) : text;
  const showResponseError = errorCode => {
    const errorObject = formPostErrors.find(errorItem => {
      return errorItem.errorCode === errorCode;
    });
    if (errorObject) {
      setFormResponseError(errorObject.message);
    } else {
      setFormResponseError(formPostErrors[0].message);
    }
  };
  const registerUser = async fullRegisterObj => {
    let myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    if (bmCookies._abck || bmCookies.ak_bmsc || bmCookies.bm_mi || bmCookies.bm_sv || bmCookies.bm_sz) {
      myHeaders.append('Cookie', `
              ${bmCookies._abck ? `_abck=${bmCookies._abck}; ` : ''}
              ${bmCookies.ak_bmsc ? `ak_bmsc=${bmCookies.ak_bmsc}; ` : ''}
              ${bmCookies.bm_mi ? `bm_mi=${bmCookies.bm_mi}; ` : ''}
              ${bmCookies.bm_sv ? `bm_sv=${bmCookies.bm_sv}; ` : ''}
              ${bmCookies.bm_sz ? `bm_sz=${bmCookies.bm_sz}; ` : ''}
          `);
    }
    let recaptchaToken;
    if (recaptchaRef.current) {
      recaptchaToken = await recaptchaRef.current.getRecaptchaToken();
    }
    if (!recaptchaToken) {
      setRecaptchaError(recaptchErrorMessage);
    } else {
      setRecaptchaError('');
    }
    let urlParams = qsToObject(window.location.href);
    let optionObj = {
      'g-recaptcha-response': recaptchaToken,
      returnUrl: `${urlParams.redirect_url ? `"returnUrl" : "${urlParams.redirect_url}",` : ''}`
    };
    let raw = _objectSpread(_objectSpread({}, fullRegisterObj), optionObj);
    let requestOptions = {
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(raw),
      redirect: 'follow',
      headers: myHeaders
    };
    let statusCode = 0;
    loaderToggle(true, setDisableSubmit);
    showGlobalLoader(true);
    await fetch(`${identityGlobal}/api/account/Register`, requestOptions).then(response => {
      showGlobalLoader(false);
      statusCode = response.status;
      return response.text();
    }).then(result => {
      let responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 200) {
        if (responseObj.isSuccess) {
          setActiveStep(STEPS.STEP5);
          // tealiumClickFunc(
          //   tealiumMergeClickData(registerSuccessAnalytics, { ...params, email: userEmail }),
          //   'Submit'
          // );
        } else if (!responseObj.isSuccess) {
          loaderToggle(false, setDisableSubmit);
          if (responseObj.errors && responseObj.errors.length) {
            throw Error(responseObj.errors[0].code);
          }
        }
      } else if (statusCode === 400) {
        loaderToggle(false, setDisableSubmit);
        if (responseObj.errors && responseObj.errors.length) {
          throw Error(responseObj.errors[0].code);
        }
      } else {
        loaderToggle(false, setDisableSubmit);
        throw Error(generalErrorCode);
      }
    }).catch(error => {
      loaderToggle(false, setDisableSubmit);
      showGlobalLoader(false);
      setResetRecaptcha(true);
      if (statusCode === 0) {
        showResponseError(generalErrorCode);
      } else {
        showResponseError(error.message);
      }
    });
  };
  const getPreviousStep = currentStep => {
    const stepValues = Object.values(STEPS);
    const currentIndex = stepValues.indexOf(currentStep);
    return currentIndex > 0 ? stepValues[currentIndex - 1] : null;
  };
  const stepBack = step => {
    const prevStep = getPreviousStep(activeStep);
    if (step) {
      setActiveStep(step);
    } else {
      if (prevStep) {
        setActiveStep(prevStep);
      }
    }
  };
  const authSteps = {
    [STEPS.STEP1]: {
      form: /*#__PURE__*/React.createElement(EmailAuthentication, {
        fields: fields,
        params: params,
        getRegisterData: () => setRegisterData({}),
        getActiveStep: activeStap => setActiveStep(activeStap),
        getEmail: email => setUserEmail(email),
        getUserFirstName: firstName => setFirstName(firstName),
        setGlobalLoader: show => showGlobalLoader(show),
        requestEvisaToken: requestEvisaToken,
        getEvisaToken: accessToken => getEvisaToken(accessToken),
        eventsAnalytics: eventsAnalytics
      }),
      title: welcomeTitle,
      subTitle: welcomeSubtitle,
      image: welcomeImage
    },
    [STEPS.STEP2]: {
      form: /*#__PURE__*/React.createElement(RegisterStep, {
        fields: fields,
        params: params,
        userEmail: userEmail,
        registerData: registerData,
        getActiveStep: activeStap => setActiveStep(activeStap),
        getRegisterData: data => setRegisterData(data),
        setGlobalLoader: show => showGlobalLoader(show),
        eventsAnalytics: eventsAnalytics
      }),
      title: registerSuccessData ? registerSuccessData.title : createAccountTitle,
      subTitle: registerSuccessData ? registerSuccessData.subtitle : formatText(createAccountSubtitle, '#email#', userEmail),
      image: createAccountImage
    },
    [STEPS.STEP3]: {
      form: /*#__PURE__*/React.createElement(TravellersType, _extends({
        registerData: registerData,
        params: params,
        getRegisterData: data => setRegisterData(data),
        getActiveStep: activeStap => setActiveStep(activeStap),
        skipButtonLabel: skipButtonLabel,
        eventsAnalytics: eventsAnalytics
      }, travellersSection)),
      title: travellersSectionTitle,
      subTitle: travellersSectionSubtitle,
      allowRender: true,
      image: travellersSectionImage
    },
    [STEPS.STEP4]: {
      form: /*#__PURE__*/React.createElement(HobbiesOrInterests, _extends({
        registerData: registerData,
        params: params,
        handleRegisterUser: fullRegisterObj => registerUser(fullRegisterObj),
        getRegisterData: data => setRegisterData(data),
        getActiveStep: activeStap => setActiveStep(activeStap),
        disableSubmit: disableSubmit,
        skipButtonLabel: skipButtonLabel,
        eventsAnalytics: eventsAnalytics
      }, hobbiesSection)),
      title: hobbiesSectionTitle,
      subTitle: hobbiesSectionSubtitle,
      allowRender: true,
      image: hobbiesSectionImage
    },
    [STEPS.STEP5]: {
      form: /*#__PURE__*/React.createElement(SuccessStep, {
        title: successTitle,
        subTitle: successSubtitle,
        icon: successIconCode,
        eventsAnalytics: eventsAnalytics
      }),
      title: '',
      subTitle: '',
      allowRender: true,
      image: successImage
    },
    [STEPS.STEP6]: {
      form: /*#__PURE__*/React.createElement(Login, {
        fields: fields,
        params: params,
        userEmail: userEmail,
        getActiveStep: activeStap => setActiveStep(activeStap),
        bmCookies: bmCookies,
        setGlobalLoader: show => showGlobalLoader(show),
        getTimerLeft: seconds => setOtpTimer(seconds),
        requestEvisaToken: requestEvisaToken,
        getEvisaToken: accessToken => getEvisaToken(accessToken),
        eventsAnalytics: eventsAnalytics
      }),
      title: `${formatText(loginTitle, '#name#', userFirstName)}!`,
      subTitle: formatText(loginSubtitle, '#email#', userEmail),
      image: loginImage
    },
    [STEPS.STEP7]: {
      form: /*#__PURE__*/React.createElement(OTPForm, {
        fields: fields,
        params: params,
        userEmail: userEmail,
        getActiveStep: activeStap => setActiveStep(activeStap),
        bmCookies: bmCookies,
        setGlobalLoader: show => showGlobalLoader(show),
        timer: otpTimer,
        requestEvisaToken: requestEvisaToken,
        getEvisaToken: accessToken => getEvisaToken(accessToken),
        eventsAnalytics: eventsAnalytics
      }),
      title: loginOTPTitle,
      subTitle: formatText(loginOTPSubtitle, '#email#', userEmail),
      image: loginOTPImage
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, process.env.STORYBOOK_MODE ? /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: '4'
    }
  }, Object.entries(STEPS).map(_ref3 => {
    let [key, value] = _ref3;
    return /*#__PURE__*/React.createElement("button", {
      key: key,
      onClick: () => setActiveStep(value)
    }, key);
  })) : null, /*#__PURE__*/React.createElement(AuthLayout, {
    form: authSteps[activeStep].form,
    title: authSteps[activeStep].title,
    subTitle: authSteps[activeStep].subTitle,
    logoImage: logoImage,
    logoLink: logoLink,
    allowRender: allowRender,
    showLoader: globalLoader,
    image: authSteps[activeStep].image,
    activeStep: activeStep,
    goBackLabel: goBackLabel,
    handleClick: step => stepBack(step),
    cardsShown: activeStep === STEPS.STEP3 && travellersSection.interestingItems && travellersSection.interestingItems.length < 5,
    carouselShown: activeStep === STEPS.STEP4 || activeStep === STEPS.STEP3 && travellersSection.interestingItems && travellersSection.interestingItems.length > 4
  }), formResponseError && formResponseError.length ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-error-response"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, formResponseError)))) : null, /*#__PURE__*/React.createElement(Recaptcha, {
    errorMessasge: recaptchaError,
    ref: recaptchaRef
  }));
};
const mainStyles = "m1k9ggq7";
const mainRtlStyles = "m1952m63";
const mainLtrStyles = "m1cjo7wf";
const StyledWrapper = _ref4 => {
  let {
    children,
    rtl
  } = _ref4;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `   ${mainStyles}  ${rtl ? mainRtlStyles : mainLtrStyles} `
  }, children);
};
export default AccountAuthorization;